import React, { forwardRef, useImperativeHandle } from "react";
import { SFStepper, SFStep } from "@sf-core";
import { Logger } from "@base-provider";

const StepContent = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    onStepChange: (data) => {
      Logger.of("App.stepper.onStepChange").info({ data });
      return { data };
    },
    onLoad: (data) => {
      Logger.of("App.stepper.onLoad").info({ data });
    },
  }));
  return <div>{props.children}</div>;
});

const Stepper = () => {
  return (
    <>
      <SFStepper
        name="mockStepper"
        onFinish={(data) => {
          Logger.of("App.stepper.onFinish").info({ data });
          return true;
        }}
      >
        <SFStep label="Step 1">
          <StepContent>test</StepContent>
        </SFStep>
        <SFStep label="Step 2" optional>
          <StepContent>
            step 2 content <input />
          </StepContent>
        </SFStep>
        <SFStep label="Step 3">
          <StepContent>
            step 3 content <input />
          </StepContent>
        </SFStep>
      </SFStepper>
    </>
  );
};

export default Stepper;
